import { AllowanceSubmitData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/AllowanceProposalForm/data';
import { BenefitSubmitData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/BenefitProposalForm/data';
import { BillableHoursSubmitData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/BillableHoursProposalForm/data';
import { BonusSubmitData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/BonusProposalForm/data';
import { SalarySubmitData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/SalaryProposalForm/data';
import { fetchFromOldApi } from '~/services/Http';

import { LegacyProposalAPI } from '../../../data';

export type LegacyProposalRequestProps = {
  proposalId?: string;
  employmentId: number;
  employeeId: number;
};

type LegacySubmitData =
  | AllowanceSubmitData
  | BenefitSubmitData
  | BillableHoursSubmitData
  | BonusSubmitData
  | SalarySubmitData;

export const submitLegacyProposal = async <
  TSubmitData extends LegacySubmitData,
>(
  proposalAPI: LegacyProposalAPI,
  data: TSubmitData | FormData,
  requestProps: LegacyProposalRequestProps,
) => {
  const { employeeId, employmentId, proposalId } = requestProps;
  const submitAsFormData = data instanceof FormData;

  const url = `/${
    submitAsFormData ? 'form' : 'json'
  }/employee/${employeeId}/employment/${employmentId}/${proposalAPI}${
    proposalId ? `/${proposalId}` : ''
  }`;

  await fetchFromOldApi(url, {
    method: proposalId ? 'PUT' : 'POST',
    ...(!submitAsFormData && {
      headers: { 'Content-Type': 'application/json' },
    }),
    body: submitAsFormData ? data : JSON.stringify(data),
  }).then((r) => r.json());
};
